var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"fill-height":"","justify-center":"","align-center":""}},[_c('v-progress-circular',{attrs:{"value":20,"height":"15","color":"primary","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }